import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

const Copyright = () => (
  <>
    <Typography component="p" variant="body1" color="textSecondary" align="center">
      <code aria-label={`Version ${process.env.REACT_APP_VERSION}`}>
        v
        {process.env.REACT_APP_VERSION}
      </code>
      <br />
      Copyright ©
      <Link color="inherit" href="https://englishworld.fr/" aria-label="Aller sur le site English World">
        English World
      </Link>
      {' '}
      {new Date().getFullYear()}
      .
    </Typography>
  </>
);

export default Copyright;
